import { Box, Card, Typography, useMediaQuery, useTheme } from '@mui/material'

interface OptionCardProps {
  icon: React.ReactNode
  title: string
  description: string
  onClick: () => void
  sx?: any
  disabled?: boolean
}

export const OptionCard = ({
  icon,
  title,
  description,
  onClick,
  sx,
  disabled,
}: OptionCardProps) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  return (
    <Box sx={{ position: 'relative', width: isMobile ? '100%' : 235, ...sx }}>
      {disabled && (
        <Typography
          sx={{
            fontSize: '0.75rem',
            color: theme.palette.grey[600],
            zIndex: 1,
            textAlign: 'right',
          }}
        >
          Coming Soon...
        </Typography>
      )}
      <Card
        onClick={onClick}
        sx={{
          width: '100%',
          height: 140,
          backgroundColor: 'transparent',
          border: '1px solid #E2E8F0',
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          gap: 0.5,
          cursor: disabled ? 'not-allowed' : 'pointer',
          transition: 'all 0.2s ease-in-out',
          opacity: disabled ? 0.6 : 1,
          '&:hover:not([disabled])': {
            backgroundColor: disabled ? 'transparent' : '#BAE6FD',
            transform: disabled ? 'none' : 'translateY(-2px)',
          },
        }}
      >
        {icon}
        <Typography fontSize={'1rem'} fontWeight={'bold'} color={'primary.dark'}>
          {title}
        </Typography>
        <Typography fontSize={'0.85rem'} color={theme.palette.grey[600]}>
          {description}
        </Typography>
      </Card>
    </Box>
  )
}
